import { tokens, Typography } from "@sunrun/experience-ui-components";
import styled from "@emotion/styled/macro";

const NonSolarHeader = ({
  src,
  alt,
  title,
  count,
  isMobile,
  isTablet,
  testId,
}: {
  src: string;
  alt: string;
  title: string;
  count: string;
  isMobile: boolean;
  isTablet: boolean;
  testId: string;
}) => {
  return (
    <NonSolarCardHeader data-testid={testId} designImage={undefined}>
      <NonSolarImage
        src={src}
        alt={alt}
        isMobile={isMobile}
        isTablet={isTablet}
      />

      <div>
        <Typography
          size={16}
          lineHeight={22}
          fontWeight="regular"
          color="white"
        >
          {title}
        </Typography>
        <NonSolarHeaderTitle
          size={24}
          lineHeight={24}
          fontWeight="regular"
          color="white"
        >
          {count}
        </NonSolarHeaderTitle>
      </div>
    </NonSolarCardHeader>
  );
};

const CardItem = ({
  title,
  value,
  testId,
  children,
}: {
  title: string;
  value: string | number;
  testId: string;
  children?: React.ReactNode;
}) => {
  return (
    <div data-testid={testId + "-card-item"}>
      <InfoTitle>{title}</InfoTitle>
      <div>{value}</div>
      {children && <div>{children}</div>}
    </div>
  );
};

const InfoTitle = styled.div`
  color: ${tokens.TINTS_HERO_BLUE_50};
  line-height: 20px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const OfferCardHeader = styled.div<{
  designImage: string | undefined;
}>`
  height: 148px;
  text-shadow: 0 0 10px ${tokens.BLACK};
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-color: #515151;
  ${({ designImage }) => {
    return designImage
      ? `background-image: linear-gradient( rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2) ), url(${designImage});`
      : "background-image: linear-gradient(180deg, #49517D 0%, #000 100%);";
  }}
  border-radius: 8px 8px 0px 0px;
  display: flex;
  flex-direction: column;
  justify-content: end;

  font-size: 12px;
  line-height: 20px;
  padding: 0 24px 12px 24px;
  color: ${tokens.WHITE};
`;

const NonSolarCardHeader = styled(OfferCardHeader)`
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
  align-items: end;
  padding: 6px 24px 12px 24px;
`;

const NonSolarImage = styled.img<{
  isMobile: boolean;
  isTablet: boolean;
}>`
  height: 148px;
  width: 104px;
`;

const NonSolarHeaderTitle = styled(Typography)`
  margin-bottom: 10px;
`;

const CardBreak = styled.div`
  border: 0.5px solid ${tokens.OFFWHITE_40};
  margin: 1rem 0;
`;

const TwoColumnLayout = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  grid-gap: 1rem;
`;

const OfferCardBody = styled.div`
  font-size: 14px;
  color: ${tokens.TINTS_OFF_WHITE_20};
  padding: 24px;
  flex-grow: 1;
`;

export {
  NonSolarHeader,
  CardItem,
  CardBreak,
  TwoColumnLayout,
  OfferCardHeader,
  OfferCardBody,
};
